import { render, staticRenderFns } from "./UsersListPage.vue?vue&type=template&id=2b38350b"
import script from "./UsersListPage.vue?vue&type=script&lang=js"
export * from "./UsersListPage.vue?vue&type=script&lang=js"
import style0 from "./UsersListPage.vue?vue&type=style&index=0&id=2b38350b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports